import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';

export const es = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizaje',
    PAGE_SUBTITLE:
      'Visualiza el consumo de la plataforma de aprendizaje. Cursos propios vs catálogo Crehana, evolución trimestral, certificaciones y satisfacción.',
    NEW_TAG: 'Nuevo',
    FRESHNESS_PREFIX: 'Última actualización:',
    FRESHNESS_DATE: '14 may, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Producto',
    PRODUCT_SELECTOR_HELPER: 'Selecciona el producto que quieres analizar',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Aprendizaje',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Aprendizaje',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'Por rutas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuarios',
    TAB_PLACEHOLDER_PATHS: 'Contenido de rutas próximamente',
    TAB_PLACEHOLDER_COURSES: 'Contenido de cursos próximamente',
    TAB_PLACEHOLDER_USERS: 'Contenido de usuarios próximamente',
    EMPTY_TITLE: 'No hay módulos disponibles',
    EMPTY_DESCRIPTION:
      'Cuando haya datos de aprendizaje disponibles, los verás aquí.',
    ERROR_TITLE: 'Error al cargar el dashboard',
    ERROR_RETRY: 'Reintentar',
    CERT_SECTION_TITLE: 'Certificados',
    CERT_SECTION_DESC:
      'Un certificado se emite cuando un usuario completa un curso que tiene certificación habilitada. Un mismo usuario puede obtener múltiples certificados (uno por curso completado).',
    HISTORIC_CHIP: 'Histórico · no depende del período',
    CERT_KPI_TOTAL_LABEL: 'Certificados emitidos (total)',
    CERT_KPI_USERS_LABEL: 'Usuarios con al menos 1 certificado',
    CERT_KPI_AVG_LABEL: 'Promedio de certificados por usuario',
    CERT_CHART_TITLE: 'Certificados emitidos por mes',
    CERT_CHART_HELPER: 'Últimos 16 meses · Certificados emitidos por mes',
    CERT_CHART_BARS_LEGEND: 'Certificados',
    CSAT_SECTION_TITLE: 'Satisfacción de Encuestas — Rutas clave',
    CSAT_TABLE_TITLE: 'Satisfacción de encuestas por ruta clave',
    CSAT_COL_ROUTE: 'Ruta',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Promedio del CSAT de los cursos de la ruta. Distinto del rating individual de curso que aparece en el bloque de métricas clave.',
    CSAT_COL_RESPONSES: 'Respuestas',
    CSAT_COL_UNIQUE_USERS: 'Usuarios únicos',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'Sin rutas clave',
    CSAT_EMPTY_DESC: 'No hay rutas lanzadas en los últimos 90 días.',
    CSAT_ERROR_TITLE: 'Error al cargar los datos de CSAT',
    CSAT_ERROR_RETRY: 'Reintentar',
  },
};
